export default "__VITE_ASSET__DeRkPF9P__"